module.exports = __webpack_public_path__ + "img/rw.abc5c89d.svg";